import "core-js/modules/es.array.index-of";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.search";
import { sessionCache } from '../cache';
export var env = {
  get isDebugMode() {
    return process.env.APP_STAGE === 'development';
  },

  get isSSR() {
    return !this.isBrowser;
  },

  get ua() {
    if (this.isBrowser) {
      return navigator.userAgent;
    }

    return this.context.ua;
  },

  get isSougouMiniProgram() {
    var isSougouMiniProgram = false;

    if (this.isMobile && this.isBrowser) {
      try {
        if (window && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.commitText) {
          isSougouMiniProgram = true;
        }

        if (window && window.jsFlx && window.jsFlx.commitText) {
          isSougouMiniProgram = true;
        }
      } catch (err) {}
    }

    return isSougouMiniProgram;
  },

  get thirdLogin() {
    if (this.isBrowser) {
      if (this._thirdLogin) return this._thirdLogin;

      if (location.search.indexOf('third=') > -1) {
        var value = location.search.match(/third=([^&]+)/)[1];
        this._thirdLogin = value;
        sessionCache.set('thirdLogin', value);
        return value;
      } else {
        return sessionCache.get('thirdLogin') || '';
      }
    }

    return '';
  },

  _thirdLogin: '',
  // 前后端一致的数据，应该将服务端渲染得到的部分初始化数据放入这里
  context: {
    ua: '',
    cookie: ''
  },

  get isBrowser() {
    return typeof window !== 'undefined';
  },

  get isTest() {
    return process.env.NODE_ENV === 'test';
  },

  assetsBaseURL: "https://" + process.env.OSS_HOST + "/",
  assetsPrefix: process.env.NODE_ENV !== 'production' ? 'gaodingx-dev/' : 'gaodingx/',

  get isMobile() {
    return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  },

  get isElectron() {
    return navigator.userAgent.indexOf('Electron') >= 0;
  }

};